import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { Image as CloudinaryImage } from 'cloudinary-react';
import Slide from '@material-ui/core/Slide';
import Button from '@material-ui/core/Button';

import SigninSignoutButton from './SigninSignoutButton';
import toJS from '../../../lib/hocs/toJS';
import Folder from '../DesktopNavbar/Folder';
import Page from '../DesktopNavbar/Page';
import { homePath } from '../../../lib/constants/links';
import { hexToRgb } from '../../../lib/functions/convert';

const scrollPosition = 350;
const heightOfBar = 7;
const boxShadow =
  '4px 4px 4px rgba(0,0,0,0.2), 0px 2px 2px rgba(0,0,0,0.14), 0px 3px 1px rgba(0,0,0,0.12)';

const styles = (theme) => {
  const rgb = hexToRgb(theme.palette.primary.main);
  const backgroundColor = `rgba(${rgb.r},${rgb.g},${rgb.b},0.9)`;
  return {
    container: {
      position: 'relative',
      width: '100%',
      height: heightOfBar,
    },
    bar: {
      backgroundColor,
      width: '100%',
      height: heightOfBar,
      content: '""',
      boxShadow,
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 100,
    },
    box: {
      backgroundColor,
      zIndex: 100,
      position: 'absolute',
      top: heightOfBar,
      padding: '0 4px 4px',
      right: 100,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderBottomLeftRadius: 4,
      borderBottomRightRadius: 4,
      boxShadow,
    },
    floatingNavbar: {
      backgroundColor: theme.palette.primary.main,
      paddingTop: 2,
      paddingBottom: 2,
      left: 0,
      paddingRight: 16,
      width: '100%',
      position: 'fixed',
      top: 0,
      borderRadius: 0,
      zIndex: 1200,
      display: 'flex',
      justifyContent: 'space-between',
    },
    floatingNavbarLeft: {
      display: 'flex',
      flexWrap: 'wrap',
      maxWidth: 'calc(100% - 120px)',
      alignItems: 'center',
    },
    addFoldersPagesButton: {
      color: theme.palette.primary.contrastText,
      height: 48,
    },
  };
};

class HeaderDesktop extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      scrolledDown: false,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop >= scrollPosition && !this.state.scrolledDown) {
      this.setState({ scrolledDown: true });
    } else if (scrollTop < scrollPosition && this.state.scrolledDown) {
      this.setState({ scrolledDown: false });
    }
  };

  renderFolderOrPage(item) {
    const { isEditingOrganization } = this.props;
    return item.type === 'FolderPage' ? (
      <Folder
        folder={item}
        key={item.id}
        isEditingOrganization={isEditingOrganization}
      />
    ) : (
      <Page page={item} key={item.id} />
    );
  }

  renderFloatingNavbar() {
    const {
      classes,
      navbarItems,
      isUserSignedIn,
      orgLogoFilename,
      canEditOrganization,
      isEditingOrganization,
    } = this.props;
    return (
      <Slide
        direction="down"
        in={this.state.scrolledDown}
        mountOnEnter
        unmountOnExit
      >
        <Paper
          className={classes.floatingNavbar}
          style={{ paddingLeft: canEditOrganization ? 89 : 16 }}
        >
          <div className={classes.floatingNavbarLeft}>
            {orgLogoFilename && (
              <a href={homePath} style={{ marginRight: 16 }}>
                <CloudinaryImage
                  publicId={orgLogoFilename}
                  crop="limit"
                  width="48"
                  height="48"
                />
              </a>
            )}
            {navbarItems.length === 0 && isEditingOrganization && (
              <Button
                href="/admin/pages"
                className={classes.addFoldersPagesButton}
              >
                + Add Pages/Folders
              </Button>
            )}
            {navbarItems.map((item) => this.renderFolderOrPage(item))}
          </div>
          <SigninSignoutButton
            signedIn={isUserSignedIn}
            style={{ height: 48 }}
          />
        </Paper>
      </Slide>
    );
  }

  render() {
    const { classes, isEditingOrganization, isUserSignedIn } = this.props;
    return (
      <React.Fragment>
        <div className={classes.bar} />
        <div className={classes.box}>
          <SigninSignoutButton signedIn={isUserSignedIn} />
        </div>
        {!isEditingOrganization && this.renderFloatingNavbar()}
      </React.Fragment>
    );
  }
}

HeaderDesktop.propTypes = {
  canEditOrganization: PropTypes.bool.isRequired,
  navbarItems: PropTypes.array.isRequired,
  isEditingOrganization: PropTypes.bool.isRequired,
  isUserSignedIn: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  orgLogoFilename: PropTypes.string,
};
HeaderDesktop.defaultProps = {};

export default toJS(withStyles(styles)(HeaderDesktop));
